import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { pageRoutes } from "../utils";

export default function MemberPaymentCancelled() {
  return (
    <div className="font-sans-clean min-h-screen bg-[#FDF8F3]">
      <section className="relative py-20 sm:py-24 overflow-hidden bg-[#722F37]">
        <div className="absolute inset-0 opacity-20 pointer-events-none ethiopian-cross" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6">
          <div className="flex items-start gap-4 text-white">
            <XCircle className="mt-1 h-7 w-7 flex-shrink-0 text-[#E7D6A8]" />
            <div>
              <h1 className="font-serif-elegant text-4xl sm:text-5xl font-bold mb-4">
                Membership payment not completed
              </h1>
              <p className="text-lg text-white/85 leading-relaxed">
                Your Stripe Checkout payment was canceled or not completed. Your
                membership is not activated by this page.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <div className="bg-white rounded-3xl border border-[#C9A227]/10 p-8 shadow-sm">
          <p className="text-gray-700 leading-relaxed">
            You can return to your member dashboard and submit the membership
            payment again when you are ready.
          </p>
          <Link
            to={pageRoutes.MemberDashboardMembership}
            className="mt-6 inline-flex rounded-xl bg-[#722F37] px-5 py-3 text-sm font-semibold text-white hover:bg-[#5A252C]"
          >
            Try again
          </Link>
        </div>
      </div>
    </div>
  );
}
